import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { CLEARBOOK_BOOKING_URL } from "@/lib/clearbook";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-40 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-8 pointer-events-none"
      }`}
    >
      <div className="flex items-stretch bg-black/80 backdrop-blur-xl border border-white/15 rounded-full overflow-hidden shadow-2xl">
        <a
          data-testid="sticky-call"
          href={ASSETS.brand.phoneTel}
          className="flex items-center gap-2 px-5 md:px-6 py-3 text-xs md:text-sm tracking-[0.18em] uppercase text-white hover:text-[color:var(--fk-gold)] transition-colors"
        >
          <Phone className="w-4 h-4" />
          <span className="hidden sm:inline">Døgnvagt ·</span>
          <span>{ASSETS.brand.phone}</span>
        </a>
        <div className="w-px bg-white/15" />
        <a
          data-testid="sticky-booking"
          href={CLEARBOOK_BOOKING_URL}
          className="px-5 md:px-6 py-3 text-xs md:text-sm tracking-[0.18em] uppercase bg-[color:var(--fk-gold)] text-black hover:bg-[color:var(--fk-gold-hi)] transition-colors"
        >
          Skal vi samarbejde?
        </a>
      </div>
    </div>
  );
};
